import Image, { ImageProps } from 'next/image'
import React from 'react'
import { getCMSImageUrl } from 'utils/cms-image'

import type { IStrapiImageAttributes } from '~/types/strapi'

type Properties = {
  attributes: IStrapiImageAttributes
} & Partial<ImageProps>

const CmsImage: React.FC<Properties> = ({ attributes, priority, ...rest }) => {
  if (!attributes) {
    return
  }

  const { url, width, height, mime, alternativeText } = attributes

  let placeholder = attributes.placeholder
  if (mime === 'image/svg+xml' || priority) {
    placeholder = undefined
  }

  return (
    <Image
      src={getCMSImageUrl(url)}
      width={width}
      height={height}
      alt={alternativeText || 'Imagem sem texto alternativo'}
      placeholder={placeholder ? 'blur' : 'empty'}
      blurDataURL={placeholder || ''}
      quality={90}
      {...rest}
    />
  )
}

export default CmsImage
